<template>
  <div>
    <search-header :form="searchForm" :formInline="formInline" @on-event="searchEvent"></search-header>
    <Table border :columns="columns" :loading="loading" :data="data" :max-height="max_height"></Table>
    <Page
      class-name="page"
      :total="total"
      size="small"
      show-sizer
      show-total
      show-elevator
      @on-change="changePage"
      @on-page-size-change="changeSize"
    />

    <sure-modal width="1100" :flag="result" @on-close="resultClose">
      <span slot="title">检测结果</span>
      <Table slot="content" border :columns="columns1" :data="data1"></Table>
    </sure-modal>
    <div ref="images" style="width:0;height:0;overflow:hidden" v-viewer="{inline: false}">
      <img v-for="(src,index) in images" :src="src" :key="index">
    </div>
  </div>
</template>
<script>
import { baseURL } from "./../../config";
import SearchHeader from "../../components/SearchHeader";
import sureModal from "../../components/sureModal";
import { dictDataList, hospital, lab } from "./../../http/commom";

import {
  selectMySampleListByPage,
  updateBarcode,
   getReportImg,
  getReportResult
} from "./../../http/customer";

export default {
  components: { SearchHeader, sureModal },
  data() {
    return {
      loading:true,
      baseURL: baseURL,
      images: [],
      result: false,
      current: 1,
      size: 10,
      total: 0,
      sexList: [],
      reportFlagList: [],
      methodList:[],
      max_height: 0,
      enabled:null,

      searchData: {
        customerCode: "",
        barcode: "",
        patientName: "",
        reportFlag: "",
        beginTime: "",
        endTime: ""
      },
      searchForm: [
        {
          fromType: "Input",
          type: "text",
          place: "医院条码",
          value: "customerCode",
        },
        {
          fromType: "Input",
          type: "text",
          place: "实验室条码",
          value: "barcode"
        },
        {
          fromType: "Input",
          type: "text",
          place: "患者名称",
          value: "patientName"
        },
        {
          fromType: "DatePicker",
          type: "daterange",
          place: "送检时间范围",
          value: "time"
        },
        { fromType: "Select", place: "报告状态", value: "reportFlag", arr: [] },

        { fromType: "Button", type: "primary", place: "搜索", event: "search" },
        { fromType: "Button", type: "primary", place: "重置", event: "reset" },
        { fromType: "Button", type: "primary", place: "返回", event: "back" }
      ],
      formInline: {},
      columns1: [
         {
          title: "实验室项目名称",
          key: "labItemName",
          minWidth: 50,
          align: "center",
          tooltip: true
        },
         {
          title: "实验室项目编码",
          key: "labItemCode",
          minWidth: 30,
          ellipsis: true,
          align: "center",

        },
        {
          title: "医院项目编码",
          key: "hospitalItemCode",
          minWidth: 30,
          ellipsis: true,
          align: "center",
        },
        {
          title: "医院项目名称",
          key: "hospitalItemName",
          minWidth: 30,
          ellipsis: true,
          align: "center",
        },
        {
          title: "结果",
          align: "center",
          key: "result"
        },
        {
          title: "提示",
          align: "center",
          key: "flag"
        },
        {
          title: "单位",
          align: "center",
          key: "unit"
        },
        {
          title: "参考范围",
          key: "refValue",
          align: "center",
        }
      ],
      data1: [],
      columns: [
        {
          title: "医院条码",
          key: "customerCode",
          minWidth: 150,
          ellipsis: true,
          align: "center",
          tooltip: true
        },
        {
          title: "检验条码",
          key: "barcode",
          minWidth: 100,
          ellipsis: true,
          align: "center",
          tooltip: true
        },
        {
          title: "医院名称",
          key: "hospitalName",
          minWidth: 130,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "实验室名称",
          key: "labName",
          minWidth: 150,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "上传时间",
          key: "createTime",
          minWidth: 150,
          ellipsis: true,
          align: "center",
          tooltip: true
        },
        {
          title: "上传方式",
          key: "method",
          minWidth: 100,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "患者姓名",
          key: "patientName",
          minWidth: 100,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "年龄",
          key: "age",
          minWidth: 80,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "性别",
          key: "sex",
          minWidth: 80,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "科室",
          key: "departName",
          minWidth: 100,
          ellipsis: true,
          align: "center",
          tooltip: true
        },
        {
          title: "病区",
          key: "wards",
          minWidth: 100,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "床号",
          key: "bedNo",
          minWidth: 100,
          ellipsis: true,
          align: "center",
          tooltip: true
        },
        {
          title: "标本类型",
          key: "sampleType",
          minWidth: 100,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "接收时间",
          key: "receiveTime",
          minWidth: 150,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "临床诊断",
          key: "clinicalDiagnose",
          minWidth: 100,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "送检医生",
          key: "doctor",
          minWidth: 100,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "采样时间",
          key: "sampleTime",
          minWidth: 150,
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "患者电话",
          key: "patientPhone",
          align: "center",
          minWidth: 100,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "报告状态",
          key: "reportFlag",
          align: "center",
          minWidth: 100,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "报告时间",
          key: "reportTime",
          align: "center",
          minWidth: 150,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "备注",
          key: "remarks",
          align: "center",
          minWidth: 100,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 240,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      getReportImg({ id: params.row.id }).then(res => {
                        if( res && res.data.data.length!=0){
                            this.$tips(this, "图片加载中,请稍等。。。", "loading");
                              let images = [];
                          for (let i in res.data.data) {
                            images.push(
                              `${
                                this.baseURL
                              }common/common/downLoadFile?attachId=${
                                res.data.data[i]
                              }&type=0`
                            );
                          }
                          this.images = images;
                          let arr = new Array();
                          this.images.map((item,index) => {
                            let img = new Image();
                            arr[index] = false;
                            img.src = item;
                            img.onload = () => {
                              arr[index] = true;
                              let isTrue = arr.every(item => item);
                              if(isTrue){
                                this.$refs.images.$viewer.show(true);
                                  this.$Message.destroy();
                              }
                            };
                          });
                        }else if(res && res.data.data.length==0){
                            this.$Message.info('暂无回传报告信息');
                        }
                      });
                    }
                  }
                },
                "报告单"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      getReportResult({ id: params.row.id }).then(res => {
                        if(res){
                            this.data1 = res.data.data;
                            this.result = true;
                        }
                      });
                    }
                  }
                },
                "检测结果"
              ),
                h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      updateBarcode({
                          customerCode: params.row.customerCode,
                        }).then(res => {
                          if(res){
                             if(res.data.data=='重传成功'){
                              this.$Message.success(res.data.data)
                            }else{
                            this.$Message.info(res.data.data)
                           }
                          }
                      });
                    }
                  }
                },
                "回传报告"
              )
            ]);
          }
        }
      ],
      data: [],
      //回传字段
      customerCode:"",
      hospitalId:"",
      labId:""
    };
  },
  mounted() {
    this.max_height = this.$getBrowerHeight(2);
    window.onresize = () => {
      this.max_height = this.$getBrowerHeight(2);
    };
    this.init();
  },
  methods: {
    //基础数据获取
    init() {
      //获取传值
      if(this.$utils.getUrlKey("enabled")=="可用"){
        this.enabled=1;
      }else if(this.$utils.getUrlKey("enabled")=="不可用"){
        this.enabled=0;
      };
      this.labId=this.$utils.getUrlKey("id");
      hospital().then(res => {
        let arr = [];
        res.forEach(item => {
          arr.push({ code: item.id, name: item.name });
        });
        this.searchForm[0].arr = arr;
        // console.log(arr)
      });
      lab().then(res => {
        let arr = [];
        res.forEach(item => {
          arr.push({ code: item.id, name: item.name });
        });
        this.searchForm[1].arr = arr;
      });
      dictDataList().then(res => {
        let arr = res.filter(item => item.t === "data_report_flag")[0].list;
        this.reportFlagList = arr;
        this.searchForm[4].arr = arr;
        this.sexList = res.filter(item => item.t === "data_sex")[0].list;
        this.methodList = res.filter(item => item.t === "data_method")[0].list;
        this.getList();
      });
    },
    //获取列表
    getList() {
      selectMySampleListByPage({
        size: this.size,
        current: this.current,
        enabled: this.enabled,
        labId:this.labId,
        ...this.searchData
      }).then(res => {
        this.total = res.total;
        res.records.forEach(item => {
          item.reportTime = this.$formatDate(item.reportTime, "01", "03");
          item.receiveTime = this.$formatDate(item.receiveTime, "01", "03");
          item.createTime = this.$formatDate(item.createTime, "01", "03");
          this.sexList.map(s => {
            if (s.code == item.sex) {
              item.sex = s.name;
            }
          });
          this.reportFlagList.map(r => {
            if (r.code == item.reportFlag) {
              item.reportFlag = r.name;
            }
          });
          this.methodList.map(m => {
            if (m.code == item.method) {
              item.method = m.name;
            }
          })
        });
        this.data = res.records;
        this.loading = false;
      });
    },
    //搜索组件按钮
    searchEvent(obj) {
      this[obj.type](obj);
    },
    search(obj) {
      this.loading = true;
      this.searchData.beginTime =this.$formatDate(obj.time[0], "01", "01");
      this.searchData.endTime = this.$formatDate(obj.time[1], "01", "01");
      this.searchData.hospitalId = obj.hospitalId;
      this.searchData.customerCode = obj.customerCode;
      this.searchData.barcode = obj.barcode;
      this.searchData.patientName = obj.patientName;
      this.searchData.reportFlag = obj.reportFlag;
      this.getList();
    },
    back(obj) {
      this.$router.go(-1);
    },
    reset(obj) {
      this.formInline={};
      this.formInline.time = ["", ""];
      this.searchData = {};
      this.getList();
    },
    resultClose() {
      this.result = false;
    },
    //改变页码
    changePage(page) {
      this.loading = true;
      this.current = page;
      this.getList();
    },
    //改变每页显示条数
    changeSize(size) {
      this.loading = true;
      this.size = size;
      this.getList();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/customerSampleM/customerSampleM.vue